import { render, staticRenderFns } from "./PatientDashboard.vue?vue&type=template&id=22f0470a&scoped=true&lang=pug"
import script from "./PatientDashboard.vue?vue&type=script&lang=js"
export * from "./PatientDashboard.vue?vue&type=script&lang=js"
import style0 from "./PatientDashboard.vue?vue&type=style&index=0&id=22f0470a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0470a",
  null
  
)

export default component.exports